import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dashInsteadOfNull',
})
export class DashInsteadOfNullPipe implements PipeTransform {

  transform(value: number | string | Date): string {
    if (!value || value === '0' || value === '0.00%' || value === '0%') {
      return '-';
    }
    return value.toString();
  }
}
